module.exports = __webpack_public_path__ + "img/hicon-kuang-zi.e1397b9c.png";